import App from '../../src/App'


export function Page() {
  return <App />
}
